import { Children, isValidElement, ReactNode } from 'react';

import { capitalize } from '@legacy/utils/string';

export const validateCompoundComponentChildren = (
  children: ReactNode,
  componentName: string,
  allowedComponentNames: string[],
) => {
  Children.forEach(children, (child) => {
    if (isValidElement(child)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const displayName = (child.type as any)?.displayName;

      if (!displayName || !allowedComponentNames.includes(displayName)) {
        throw new Error(
          `${capitalize(componentName)} only accepts compound components. Found: ${displayName || 'unknown component'}. `,
        );
      }
    } else if (
      child !== null &&
      child !== undefined &&
      child !== false &&
      child !== ''
    ) {
      // Non-React elements (strings, numbers, etc.)
      throw new Error(
        `${capitalize(componentName)} only accepts compound components. Raw content is not allowed. ` +
          `Use compound components to wrap content.`,
      );
    }
  });
};
